import { useAppSelector } from 'reduxTyped'

import { getIsUserFlagEnabled } from 'common/core/selectors/appSelectors'

import { UserFlag } from '../featureFlagsService/constants'

import useIntercomFinAIAgentWidget from './useIntercomFinAIAgentWidget'

const IntercomFinAIAgent = () => {
  const { loadIntercomFinAIAgent } = useIntercomFinAIAgentWidget()
  const isFinAIExperimentEnabled = useAppSelector((state) =>
    getIsUserFlagEnabled(state, UserFlag.ENABLE_FIN_AI_EXPERIMENT),
  )

  if (isFinAIExperimentEnabled) {
    loadIntercomFinAIAgent()
  }

  return null
}

export default IntercomFinAIAgent
